<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de logos</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- INSTRUÇÕES -->
            <div class="col-sm-12">
              <div class="form-group">
                <span style="color: red">Instruções: Imagem 400x250 e Fundo branco ou transparente</span>
              </div>
            </div>

            <!-- NOME -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="nome">Nome</label>
                <input class="form-control" id="nome" placeholder="Nome" v-model="formData.nome" />

                <span style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ARQUIVO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Arquivo</label>
                <input class="form-control" type="file" @change="onChange" />

                <span style="color: red" v-for="error in v$.upload_files.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="sendFileS3()">Cadastrar</button>
          <a type="submit" href="/admin/logos" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados"],

  components: { Loading },

  data() {
    return {
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      nome: "",
      upload_files: "",
    });

    const rules = computed(() => {
      return {
        nome: { required },
        upload_files: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {},

  methods: {
    onChange(e) {
      this.formData.upload_files = e.target.files[0];
    },

    async sendFileS3() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("id", "1");
          formData.append("path", "rochaleiloes2/logos/");
          formData.append("file", this.formData.upload_files);

          axios
            .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
            .then((response) => {
              console.log("ENVIANDO PARA O BANCO\n");

              this.uploadFD(response.data.key);
            })
            .catch((error) => {
              console.log(error);

              this.isLoading = false;
              this.showErrorMessageWithButton("Ops..", error.response.data.error);
              console.log(error);
              reject();
            });
        });
      }
    },

    async uploadFD(file) {
      this.isLoading = true;

      let fileName = file.split("/");

      let fd = new FormData();
      fd.append("nome", this.formData.nome);
      fd.append("file", fileName[fileName.length - 1]);
      fd.append("path", "rochaleiloes2/logos");

      console.log("Cadastrando");
      console.log(fd);

      axios
        .post(`/admin/logo/store`, fd)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Logo cadastrada", "/admin/logos");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },
  },
};
</script>
